import React, {useState, useImperativeHandle, forwardRef} from 'react';
import * as _ from 'lodash';
import './filters.scss';

const Filters = forwardRef(({places, onSubmitForm, onSelectPlace}, ref) => {

    const [cities] = useState(_.sortBy(_.uniq(places.map((p) => p.city))));
    const [name, setName] = useState('');
    const [city, setCity] = useState('');
    const [selectedPlace, setSelectedPlace] = useState(null);

    useImperativeHandle(ref, () => ({
        setPlace(place) {
            setSelectedPlace(place);
        }
    }));

    const handleClick = (event) => {
        onSubmitForm(name, city);
    };

    const onInputChange = (event) => {
        setName(event.target.value);
    }

    const onSelectChange = (event) => {
        setCity(event.target.value);
    }

    const onClickPlace = (place) => {
        setSelectedPlace(place);
        onSelectPlace(place);
    }

    const onClickBackButton = () => {
        setSelectedPlace(null);
        onSubmitForm(name, city);
    }

    if (selectedPlace === null) {
        return (
            <div className={'filters'}>

                <form>
                    <div className={'fields'}>
                        <input value={name} onChange={onInputChange} type="text" name="name" placeholder="Nazwa"/>
                        <select defaultValue={city} onChange={onSelectChange}>
                            <option key={'all'} value={''}>Wszystkie miejscowości</option>
                            {cities.map((city, idx) => <option key={idx} value={city}>{city}</option>)}
                        </select>
                    </div>
                    <button type={'button'} onClick={handleClick}>Filtruj</button>
                </form>

                <div className={'points-list'}>

                    {places.map((place) =>
                        <div key={place.id} className={'point'}>
                            <div className={'info'}>
                                <h3>{place.name}</h3>
                                {place.street}<br/>
                                {place.post_code} {place.city}
                                {place.phone && (<><br/><span>tel. {place.phone}</span></>)}
                                {place.additional_info && (<><br/><span>{place.additional_info}</span></>)}
                            </div>
                            <div className={'details'} onClick={() => onClickPlace(place)}>
                                <img src={'./right-arrow.svg'} alt={'details'}/>
                            </div>
                        </div>
                    )}

                </div>

            </div>
        );
    } else {
        return (
            <div className={'filters place-details'}>
                <button className={'back-btn'} onClick={onClickBackButton}>Powrót</button>
                <div className={'info'}>
                    <h3>{selectedPlace.name}</h3>
                    {selectedPlace.street}<br/>
                    {selectedPlace.post_code} {selectedPlace.city}
                    {selectedPlace.phone && (<><br/><span>tel. {selectedPlace.phone}</span></>)}
                    {selectedPlace.additional_info && (<><br/><span>{selectedPlace.additional_info}</span></>)}
                </div>
            </div>
        );
    }

});

export default Filters;
